export enum Code {
  SUCCESS,
  VERIFY_EMAIL_ERR,
  ALREADY_REGISTERED,
  INVALID_DATA_ERR,
  LOCAL_STORAGE_SET_ERR,
  LOCAL_STORAGE_TOKEN_NOT_FOUND,
  JWT_TOKEN_NOT_PROVIDED,
  JWT_TOKEN_INVALID,
  API_RESPONSE_ERR,
  RECAPTCHA_TOKEN_INVALID,
  SUSPICIOUS_USER,
  UNKONWN_ERR,
}

export interface tryCatchResponse<T> {
  response: T | null;
  error: any | null;
}
